export const Constants = {
  ThumbnailsClassName: 'letters-thumbnails',
  noneValue: 'none',
  NoneLabel: 'None',
  fixedRatio: 'Fixed ratio (1:1)',
  fluid: 'Fluid',
  fieldTitle: 'Field Title',
  thumbnailItemData: 'ThumbnailItemData',
};
